import { useDeepMemo } from "./auth-service-tools30.js";
import useIntl from "./auth-service-tools31.js";

const useMessage = (messageId, values) => {
  const intl = useIntl();

  if (!messageId) {
    return void 0;
  }

  return intl.formatMessage({
    id: messageId
  }, values);
};

const useMessages = function () {
  let messageIdMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let values = arguments.length > 1 ? arguments[1] : undefined;
  const intl = useIntl();
  return useDeepMemo(() => Object.entries(messageIdMap).reduce((acc, _ref) => {
    let [key, messageId] = _ref;
    acc[key] = messageId ? intl.formatMessage({
      id: messageId
    }, values) : void 0;
    return acc;
  }, {}), [messageIdMap, intl, values]);
};

function makeUseMessage() {
  return useMessage;
}

function makeUseMessages() {
  return useMessages;
}

export { makeUseMessage, makeUseMessages };